import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { EpodConfirmPopupComponent } from '@core/controls/_dialogs/epod-confirm-popup/epod-confirm-popup.component';
import { EpodCustomContentPopupComponent } from '@core/controls/_dialogs/epod-custom-content-popup/epod-custom-content-popup.component';
import { ConfirmDialogData, CustomContentDialogData, OpenPopupForCustomComponent } from '@core/models/dialogs/dialog-data.model';
import { ConfirmationDialogResult, CustomContentDialogResult } from '@core/models/dialogs/dialog-results.model';

@Injectable({
  providedIn: 'root'
})
export class DialogsService {

  private _defaultDialogData: Partial<ConfirmDialogData> = {
    confirmButtonText: 'Potwierdz',
    cancelButtonText: 'Anuluj',
    iconText: 'error_outline'
  }

  constructor(private readonly _dialog: MatDialog,
    private readonly _scrollStrategyOptions: ScrollStrategyOptions
  ) {
  }

  openConfirmation(data: Partial<ConfirmDialogData>): MatDialogRef<unknown, ConfirmationDialogResult> {
    const mergedData = {
      ...this._defaultDialogData,
      ...data,
      maxWidth: '85vw'
    };

    return this._dialog.open(EpodConfirmPopupComponent, {
      data: mergedData,
      scrollStrategy: this._scrollStrategyOptions.noop()
    });
  }

  openCustomContent(data: Partial<CustomContentDialogData>, customConfig?: MatDialogConfig): MatDialogRef<unknown, CustomContentDialogResult> {
    const mergedData = {
      ...this._defaultDialogData,
      ...data
    };
    const userConfig = customConfig? customConfig: {};
    return this._dialog.open(EpodCustomContentPopupComponent, {
      data: mergedData,
      scrollStrategy: this._scrollStrategyOptions.noop(),
      width: '85vw',
      maxWidth: '85vw',
      ...userConfig,
    });
  }

  openPopupForCustomComponent<D, R>(data: OpenPopupForCustomComponent, config?: MatDialogConfig): MatDialogRef<unknown, R> {
    return this._dialog.open<unknown, D, R>(data.component, {
      ...config,
      data: data.data,
      scrollStrategy: this._scrollStrategyOptions.noop(),
      width: '85vw',
      maxWidth: config?.maxWidth ? config.maxWidth : '85vw'
    });
  }
}
